export default class ApplicationService {
  axiosIns = null

  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  list() {
    return this.axiosIns.get(`${this.jwtConfig.main.usersEndpoints}/applications`)
  }

  listSecurityLogs(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.usersEndpoints}/applications/security-logs`, { params })
  }

  open(id, payload) {
    return this.axiosIns.post(`${this.jwtConfig.main.usersEndpoints}/applications/${id}/open`, payload)
  }

  requestAccess(id) {
    return this.axiosIns.post(`${this.jwtConfig.main.usersEndpoints}/applications/${id}/request`)
  }
}
